import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { LEVELS } from "@/lib/content";
import { bookingHref } from "@/lib/site";
import { Reveal } from "./Reveal";

export const Levels = () => (
  <div className="grid grid-cols-1 border-l border-t border-white/10 lg:grid-cols-3">
    {LEVELS.map((l, i) => (
      <Reveal key={l.key} delay={i * 0.1} className={`relative flex flex-col border-b border-r border-white/10 p-8 md:p-10 ${i === 0 ? "bg-white/[0.03]" : ""}`}>
        <div data-testid={`level-card-${l.key}`} className="flex h-full flex-col">
          {l.tag && <span className="mb-6 self-start bg-brand px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-white">{l.tag}</span>}
          <h3 className="font-display text-4xl uppercase leading-none text-white">{l.name}</h3>
          <p className="mt-2 text-sm uppercase tracking-[0.15em] text-neutral-500">{l.who}</p>
          <ul className="mt-8 flex-1 space-y-3">
            {l.topics.map((t) => (
              <li key={t} className="flex gap-3 text-neutral-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />{t}</li>
            ))}
          </ul>
          <Link to={bookingHref("egitim")} data-testid={`level-booking-${l.key}`} className="group mt-10 flex items-center justify-between border border-white/20 px-5 py-3 font-semibold uppercase tracking-wider text-white transition-colors hover:border-brand hover:bg-brand">
            Eğitim talebi <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    ))}
  </div>
);
